import React from "react";
import { useState, useEffect, useFormContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Invoice } from "models/InvoiceModel";
import { Payment } from "models/PaymentModel";
import { Item, emptyItem } from "models/ItemModel";
import AsyncSelect from "react-select/async";
import { Calculate } from "helpers/CalculateHelpers"
import { useSearchParams } from 'react-router-dom';
import { CommonDataColumn } from "models/BaseModel";
import { Product } from "models/ProductModel";
import { Inventory } from "models/InventoryModel";


const InvoiceForm: React.FC = () => {
  const width = { product: 34, price: 10, qty: 10, unit: 10, gross: 8, discountP: 5, discountA: 8, depositP: 5, depositA: 8, taxable: 8, taxP:5, taxA:8, netAmount: 10 }
  const width2 = { date: 16, sno: 12, insurance: 20, mop: 18, receivedby: 18, amount: 18 }
  const [formId, formName] = [Code.Form.Id.INVOICE, Code.Form.Name.INVOICE];
  const {keyId, setKeyId, activeId, setActiveId, loading, setLoading, hasUnsaved, setHasUnsaved, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [paymentData, setPaymentData] = useState<Payment[]>([]); 
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [insurerOptions, setInsurerOptions] = Hooks.Form.Options();
  const [creditOptions, setCreditOptions] = Hooks.Form.Options();
  const [mopOptions, setMopOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Invoice>({});
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const [initialData, setInitialData] = useState<Invoice>({});
  const [unitOptions, setUnitOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions  ] = Hooks.Form.Options();
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [selectedProduct, setSelectedProduct] = useState<OptionType | null>(null);
  const [localSkucode, setLocalSkucode] = useState<string>('');
  const emptyOptions = Utility.Get.OptionValues([Code.Option.Common.NA]);
  const [paymentClient, setPaymentClient] = useState<boolean>(false);
  const [paymentInsurer1, setPaymentInsurer1] = useState<boolean>(false);
  const [paymentInsurer2, setPaymentInsurer2] = useState<boolean>(false);
  const [creditVisible, setCreditVisible] = useState<boolean>(false);
  const [totalReceived, setTotalReceived] = useState<number>(0);
  const [totalBalance, setTotalBalance] = useState<number>(0);

  const [clientPayment, setClientPayment] = useState<string>('');
  const [insurer1Payment, setInsurer1Payment] = useState<string>('');
  const [insurer2Payment, setInsurer2Payment] = useState<string>('');

  const [termOptions, setTermOptions] = Hooks.Form.Options();
  const [allTermOptions, setAllTermOptions] = Hooks.Form.OptionMore();

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const userId = Utility.Storage.UserId();
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const PrivPayment = Hooks.Privilege.List(Code.Form.Id.PAYMENT)
  const RoleSpecial = Hooks.Privilege.RoleSpecial();
  Hooks.Privilege.HasOpen(Privilege);
  
   
  useEffect(() => {

    console.clear();

    //console.log("Utility.Date.Current()------>",Utility.Date.Current());
    //console.log("Utility.Date.getLocalDate()------>",Utility.Date.getLocalDate());

    console.log("keyId------>",keyId);
  
    Files.Json.Http(Code.File.UNIT, Code.Option.Common.NOTHING, setUnitOptions, setError);
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.NA, setDoctorOptions, setError);
    Files.Json.API(Code.File.INSURER, Code.Option.Common.NA, setInsurerOptions, setError);
    Files.Json.API(Code.File.MOP, Code.Option.Common.NA, setMopOptions, setError);
    Files.Json.Http(Code.File.CREDIT+Code.File.TYPE, Code.Option.Common.SELECT, setCreditOptions, setError);
    Files.Json.API(Code.File.SEGMENT, Code.Option.Common.SELECT, setSegmentOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INVOICE_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.SALE_STATUS, Code.Option.Common.NA, setTypeOptions, setError);
    Files.Json.API(Code.File.TERM, Code.Option.Common.NA, setAllTermOptions, setError);
    Files.Json.API(Code.File.USER, Code.Option.Common.SELECT, setUserOptions, setError);

    API.Data.GetByKeyId<Invoice>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {

      //console.log("Raw Data------))",data.invoice_date);

      setActiveId(data.invoice_active); 
      const formData = await Form.Map.Data(data);
      const clientData = await API.Data.getClientNameNumber(data.client_id);
      const finalData = {
        ...formData,
        ...clientData, 
      };
      setFormData(finalData);
      setInitialData(finalData);

      console.log("finalData------))",finalData);

      Utility.Storage.Set(Code.Form.Name.INVOICE,data.invoice_id);
      if(PrivPayment.ALL || PrivPayment.VIEW) callPaymentList(data.invoice_id);
      if(data.invoice_insurer1_amount && data.invoice_insurer1_amount > 0) setPaymentInsurer1(true);
      if(data.invoice_insurer2_amount && data.invoice_insurer2_amount > 0) setPaymentInsurer2(true);
      setLoading(false);
    }})

    const onNewEntry = async () => {
      if(keyId===Code.Key.NEW) {
        if(clientId){
          const clientName = await API.Data.GetClientName(Number(clientId));
          const newData = {
            client_id: Number(clientId),
            client_name: Utility.Value.Text(clientName), 
          };
          setFormData(newData);
        }
        setFormData((prev) => ({
          ...prev, 
          segment_id: Code.Option.Segment.OPTICAL, 
          credit_id: Code.Option.Credit.STOCKOUT,
          user_id: userId,
        }));
        setInitialData(formData);
      }
      setLoading(false);
    };
    onNewEntry();

  }, []);
  
  useEffect(() => { 
    const hasChanged = JSON.stringify(formData) !== JSON.stringify(initialData);
    setHasUnsaved(hasChanged); 
  }, [formData, initialData]);

  useEffect(() => {
    if(allTermOptions){
      const filteredTerms = allTermOptions.filter(option => (option.data1 === formId.toString() || option.value == 2));
      if(filteredTerms.length > 1) { 
        setTermOptions(filteredTerms); 
        if(keyId===Code.Key.NEW){
          setFormData((prev) => ({...prev, term_id: filteredTerms[1].value || Code.Option.Common.NONE}));
        }
      }
      else setTermOptions(emptyOptions);
    }
  }, [allTermOptions]);

  const callPaymentList = async (invoiceId: number | undefined) => {
    if (!invoiceId) return;  
      const url = API.Build.FormApiEndpint(Code.Form.Name.PAYMENT, 0, Name.Payment.Id, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Payment.Date, 
        Name.Payment.Number, 
        Name.Insurer.Id, 
        Name.Common.SequenceId,
        Name.Insurer.Name, 
        Name.Common.ModeName, 
        Name.User.FirstName, 
        Name.Payment.Amount            
      ]),
      [Name.Invoice.Id]: invoiceId,
    });
    await API.Data.List<Payment>(url, setPaymentData, setError, setLoading);
 };

  useEffect(() => { 
    //console.log("invoice_date changed:", formData.invoice_date);
  }, [formData.invoice_date]);

 useEffect(() => {
  //console.log("paymentData:", paymentData);

  if (!formData || !paymentData) return;
 
  // Check invoice_client_amount
  if (formData.invoice_client_amount != null) {
    if(formData.invoice_client_amount > 0){
      const total = paymentData.filter(x => x.insurer_id === 2).reduce((sum, x) => sum + (x.payment_amount ?? 0), 0) || 0;
      const isEqual = total == formData.invoice_client_amount ? true : false ;
      setClientPayment(paymentData.find(x => x.insurer_id === 2)?.payment_key?.toString() || '');
      isEqual ?  setPaymentClient(false) : setPaymentClient(true);
    } else setPaymentClient(false)
  } else setPaymentClient(false)

  if (formData.invoice_insurer1_amount != null) {
    if(formData.invoice_insurer1_amount > 0){
      const total = paymentData.filter(x => x.insurer_id === formData.insurer1_id && x.sequence_id === 12).reduce((sum, x) => sum + (x.payment_amount ?? 0), 0) || 0;
      const isEqual = total == formData.invoice_insurer1_amount ? true : false ;
      setInsurer1Payment(paymentData.find(x => x.insurer_id === formData.insurer1_id && x.sequence_id === 12)?.payment_key?.toString() || '');
      isEqual ?  setPaymentInsurer1(false) : setPaymentInsurer1(true);
    } else setPaymentInsurer1(false)
  } else setPaymentInsurer1(false)

  if (formData.invoice_insurer2_amount != null) {
    if(formData.invoice_insurer2_amount > 0){
      const total = paymentData.filter(x => x.insurer_id === formData.insurer2_id && x.sequence_id === 13).reduce((sum, x) => sum + (x.payment_amount ?? 0), 0) || 0;
      const isEqual = total == formData.invoice_insurer2_amount ? true : false ;
      setInsurer2Payment(paymentData.find(x => x.insurer_id === formData.insurer2_id && x.sequence_id === 13)?.payment_key?.toString() || '');
      isEqual ?  setPaymentInsurer2(false) : setPaymentInsurer2(true);
    } else setPaymentInsurer2(false)
  } else setPaymentInsurer2(false)

  //const received = paymentData.reduce((sum, x) => sum + (x.payment_amount ?? 0), 0) | 0;
  const received = Number(paymentData.reduce((sum, x) => sum + (x.payment_amount ?? 0), 0).toFixed(2));
  setTotalReceived(received);

}, [paymentData,formData]);

useEffect(() => {
  const balance = Number(formData.invoice_payable_amount) - totalReceived;
  setTotalBalance(balance);
}, [totalReceived]);

 useEffect(()=>{
  //console.log("localSkucode:",localSkucode);
 },[localSkucode])

 useEffect(()=>{
  //console.log("paymentInsurer1:",paymentInsurer1);
 },[paymentInsurer1])

 const onItemChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;
    const noneCalculate = Code.Item.NoneCalculateFields.includes(name);
    const updatedValue = value;
    //const updatedValue = noneCalculate ? value : (value ? Number(value) || 0 : 0);
  
   //console.log("updatedValue", updatedValue);

    setFormData((prevData) => {
      const updatedItems = [...prevData.items!];
      const key = name as keyof Item;
  
      if (name === 'selected') {
        updatedItems[index] = {
          ...updatedItems[index],
          [key]: checked,
          item_active: checked ? 4 : 2, 
        };
      } else {
        updatedItems[index] = {
          ...updatedItems[index],
          [key]: updatedValue,
        };
      }
  
      updatedItems[index] = Calculate.ItemValues(updatedItems[index]);
      const grandTotals = Calculate.GrandTotals(updatedItems,formName);
  
      return {
        ...prevData,
        items: updatedItems,
        invoice_gross_amount: grandTotals.invoice_gross_amount || 0,
        invoice_discount_amount: grandTotals.invoice_discount_amount || 0,
        invoice_deposit_amount: grandTotals.invoice_deposit_amount || 0,
        invoice_taxable_amount: grandTotals.invoice_taxable_amount || 0,
        invoice_tax_amount: grandTotals.invoice_tax_amount || 0,
        invoice_net_amount: grandTotals.invoice_net_amount || 0,
        invoice_payable_amount: grandTotals.invoice_payable_amount || 0,
      };
    });
  };

  const addItem = async () => {
    
    if (localSkucode || (selectedProduct?.value  && selectedProduct?.value > 0) ) {   
      let productId = selectedProduct?.value || 0;
      let productName = selectedProduct?.label || '';
      let specificationId = 2;
      let productComment = '';
      let utnCode = ''
      let skuCode = ''
      let inventoryId = 2;
      let salePrice = 0;
      let quantity = 1;
      let discountPercent = 0;
      let discountAmount = 0;
      let taxPercent = 0;
     
      const fields = Utility.Join.Fields([
        Name.Inventory.SKU,
        Name.Inventory.UTN,
        Name.Inventory.SerialNo,
        Name.Inventory.Sale,
        Name.Inventory.Data,
        Name.Product.Id,
        Name.Specification.Id,
      ]);

      if(productId == 0){
        const inventoryData = await API.Data.GetInventoryViewById<Inventory>(localSkucode);
        if(inventoryData){
          utnCode = inventoryData.inventory_utncode || '';
          skuCode = inventoryData.inventory_skucode || '';
          specificationId = inventoryData.specification_id || 2;
          productId = inventoryData.product_id || productId;
          inventoryId = inventoryData.inventory_id || inventoryId;
          salePrice = inventoryData.inventory_sale_price || 0;
          productComment = Utility.Get.ProductSummary(inventoryData, specificationId);
          productName = inventoryData.product_name || productName;
          if(salePrice==0) salePrice = inventoryData.product_sale_price || 0;
          discountPercent = inventoryData.offer_percentage || 0;
          discountAmount = inventoryData.offer_amount || 0;
          taxPercent = inventoryData.tax_percentage || 0;
        }
        else { Utility.Message.Warning(["No inventory found for the entered SKU/UTN"],setMessage); return; }
      }
      else
      {
        const productData = await API.Data.GetProductViewById<Product>(productId);
        if(productData){
          productName = productData.product_name || productName;
          productComment = productData.product_comment || '';
          salePrice = productData.product_sale_price || 0;
          discountPercent = productData.offer_percentage || 0;
          discountAmount = productData.offer_amount || 0;
          taxPercent = productData.tax_percentage || 0;
          quantity = productData.product_min_sale || 1;
        }
        else{ Utility.Message.Warning(["Product not found"],setMessage); return; }
      }
      

      const newItem: Item = { 
        ...emptyItem, 
        item_utncode: utnCode,
        item_skucode: skuCode,
        inventory_id: inventoryId,
        item_price: Number(salePrice),
        item_quantity: quantity,
        item_net_amount: Number(salePrice * quantity),
        ...(productId !== 0 && {
          product_id: productId,
          product_name: productName,
        }),
        item_comment: productComment,
        stock_status_id: 1,
        item_discount_percentage: Number(discountPercent),
        item_discount_amount: Number(discountAmount),
        item_tax1_percentage: Number(taxPercent),
      };


      setFormData((prev) => {
        const updatedItems = [...(prev.items || []), newItem];
        const newIndex = updatedItems.length - 1;

        const fakeEvent = {
          target: { name: "item_price", value: salePrice, type: "number", checked: false },
        } as unknown as React.ChangeEvent<HTMLInputElement>;

        const updatedItem = Calculate.ItemValues(updatedItems[newIndex]);
        updatedItems[newIndex] = updatedItem;

        const grandTotals = Calculate.GrandTotals(updatedItems, formName);

        return {
          ...prev,
          items: updatedItems,
          invoice_gross_amount: grandTotals.invoice_gross_amount || 0,
          invoice_discount_amount: grandTotals.invoice_discount_amount || 0,
          invoice_deposit_amount: grandTotals.invoice_deposit_amount || 0,
          invoice_taxable_amount: grandTotals.invoice_taxable_amount || 0,
          invoice_tax_amount: grandTotals.invoice_tax_amount || 0,
          invoice_net_amount: grandTotals.invoice_net_amount || 0,
          invoice_payable_amount: grandTotals.invoice_payable_amount || 0,
        };
      });


      // TODO: handle inventoryData (set state, update form, etc.)
      //console.log("formData------>",formData);
      setSelectedProduct({value: 0, label: 'Select'});
      setLocalSkucode('');
    } else { Utility.Message.Warning(["Select Product Name or SKU/UTN Number"],setMessage); }
  };


  const calculateFunction = (updatedFormData: any) => {
    let roundOffAmount = Number(updatedFormData.invoice_roundoff_amount) || 0;
    let netAmount = Number(updatedFormData.invoice_net_amount) || 0;
    let payableAmount = Number(updatedFormData.invoice_payable_amount) || 0;
    let insurer1Amount = Number(updatedFormData.invoice_insurer1_amount) || 0;
    let insurer2Amount = Number(updatedFormData.invoice_insurer2_amount) || 0;

    payableAmount = netAmount + roundOffAmount;
    let clientAmount = payableAmount - (insurer1Amount + insurer2Amount);

    return {
      ...updatedFormData,
      invoice_payable_amount: Utility.Maths.toDecimal(payableAmount),
      invoice_client_amount: Utility.Maths.toDecimal(clientAmount),
    };
  };

  useEffect(() => {
    const creditId = formData.credit_id || 0;
    if(creditId == Number(Code.Option.Credit.WALLET)){
      setCreditVisible(true);
      // if(keyId===Code.Key.NEW){
      //   const adjustmentAmount = formData.invoice_adjustment_amount || 0;
      //   setFormData((prev) => ({
      //     ...prev, 
      //     invoice_adjustment_amount: adjustmentAmount==0 ?  0 : adjustmentAmount,
      //   }) );
      // }
    } else { 
      setCreditVisible(false);
      setFormData((prev) => ({
        ...prev, 
        invoice_adjustment_amount: 0,
        invoice_giftcard_mode:  2,
        invoice_giftcard_amount: 0,
      }) );
    }
    
  }, [formData.credit_id]);

  useEffect(() => {
    setFormData((prev) => calculateFunction(prev));
  }, [ formData.invoice_net_amount, formData.invoice_roundoff_amount, formData.invoice_payable_amount ]);

  const handleSave = async (data: typeof formData) => {
    console.log("Data to Save: ", data);
    const addonData = await API.Data.AddonData(data, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...data,
      ...addonData,
      invoice_start_date: Utility.Date.DateOrNull(data.invoice_start_date),
      invoice_end_date: Utility.Date.DateOrNull(data.invoice_end_date),
    });
    console.log("Final Data to Save: ", finalData);
    const response = await API.Data.Save(formName, keyId, finalData, setMessage, true);
    if (response) {
      // only require if form remain open after creating/update record
    }
  };

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e, setMessage)) return;
    await handleSave(formData);
  };

  const onRefresh = () => {
    const InvoiceId = Utility.Storage.Get(Code.Form.Name.INVOICE);
    if(InvoiceId){
      callPaymentList(Number(InvoiceId));
    }
  };

  const generateDispense = async () => {
    console.log('Generate Dispense Started');
    const response = await API.Data.generateDispense(Code.Form.Id.INVOICE, formData.invoice_id, setMessage);
    if(response){
      Utility.Message.Info(['Dispense generated successfully'],setMessage);
    }
  };

  const handleDelete = async (ActiveId: number | undefined) => {
    ActiveId = Utility.Set.toggleStatus(ActiveId);
    const updatedData = { 
      ...formData, 
      invoice_active: ActiveId,
      items: formData.items?.map((item) => ({ 
        ...item, 
        item_active: ActiveId,
      })),
    };
    setFormData(updatedData);
    await handleSave(updatedData); 
  };
  

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => handleDelete(activeId)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} hasUnsaved={hasUnsaved} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} formId={formId} Privilege={Privilege} print={true}>
            {keyId !== Code.Key.NEW && (
              <Control.Form.CheckList title='Options'>
                <Button.Action title={'+ Dispense'} info={'Create dispense with same items and amount from this invoice'} onClick={generateDispense} />
              </Control.Form.CheckList>
            )}
          </Button.Save>
          <Control.Tab.Header titles={["Details", "Payment", "More"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Invoice.Date} value={formData.invoice_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} require={true} currentDate={true} />
                <Field.FilterSelect id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions} setFormData={setFormData} size={[1,20,1]} />
                <Field.Select id={Name.Common.SegmentId} value={formData.segment_id} title={Title.Segment} options={segmentOptions} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} size={[1,20,1]} />
                <Field.FilterSelect id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions} setFormData={setFormData} size={[1,20,1]} />
                <Field.FilterSelect id={Name.User.Id} value={formData.user_id} title={Title.Dispenser} options={userOptions} setFormData={setFormData} size={[1,20,0]} require={true} disabled={!RoleSpecial.includes(Code.RoleSpecial.ENABLE_DISPENSER_NAME)} />
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.ClientAsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.SearchOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Product.Id} title={Title.Product} size={[0,50,1]}>
                  <AsyncSelect id={Name.Product.Id} value={selectedProduct} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.PRODUCT, Code.Mapping.product.value, Code.Mapping.product.label)} styles={Code.Style.SearchOption} onChange={(selected) => setSelectedProduct(selected as OptionType | null)} placeholder="Search" />
                </Field.Header>
                <Field.Text id={Name.Item.SKU} value={localSkucode} title={Title.SkuUtn} onChange={(e) => setLocalSkucode(e.target.value)} size={[1,20,1]} />
                <Button.FrameAction title="+" info={Info.AddProduct} onClick={addItem} size={[1,20,1]} className='pt6' />
              </Control.Row>
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Grid.Items values={[
                    [Title.Product, width.product], 
                    [Title.Price, width.price, Code.Align.RIGHT], 
                    [Title.Qty, width.qty, Code.Align.RIGHT],
                    [Title.Unit, width.unit],
                    [Title.Gross, width.gross, Code.Align.RIGHT, false],
                    [Title.Discount, width.discountP + width.depositA, Code.Align.CENTER],
                    [Title.Deposit, width.depositP + width.depositA, Code.Align.CENTER, false],
                    [Title.Taxable, width.taxable, Code.Align.RIGHT, false],
                    [Title.Tax, width.taxP + width.taxA, Code.Align.CENTER],
                    [Title.NetAmount, width.netAmount, Code.Align.RIGHT]
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {formData.items?.map((item, index) => (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Form.Check index={index} checked={item.selected} handleItemChange={(index, e) => onItemChange(index, e)} />
                        <Control.Form.Text id={Name.Product.Name} value={Utility.Format.ProductQuick(item.product_name,item.item_skucode,item.item_utncode)} size={[width.product]} disabled={true} />
                        <Control.Form.Number id={Name.Item.Price} value={item.item_price} size={[width.price]} onChange={(e) => onItemChange(index,e)}  />
                        <Control.Form.Number id={Name.Item.Quantity} value={item.item_quantity} size={[width.qty]} onChange={(e) => onItemChange(index,e)}  />
                        <Control.Form.Option id={Name.Unit.Id} value={item.unit_id} optionValues={unitOptions} size={[width.unit]} onChange={(e) => onItemChange(index,e)}  />
                        <Control.Form.Number id={Name.Item.Gross} value={item.item_gross_amount} size={[width.gross]} onChange={(e) => onItemChange(index,e)} visible={false} />
                        <Control.Form.Number id={Name.Item.DiscountP} value={item.item_discount_percentage} size={[width.discountP]} onChange={(e) => onItemChange(index,e)} placeholder='%'  />
                        <Control.Form.Number id={Name.Item.DiscountA} value={item.item_discount_amount} size={[width.discountA]} onChange={(e) => onItemChange(index,e)} />
                        <Control.Form.Number id={Name.Item.DepositP} value={item.item_deposit_percentage} size={[width.depositP]} onChange={(e) => onItemChange(index,e)} visible={false} placeholder='%' />
                        <Control.Form.Number id={Name.Item.DepositA} value={item.item_deposit_amount} size={[width.depositA]} onChange={(e) => onItemChange(index,e)} visible={false} />
                        <Control.Form.Number id={Name.Item.Taxable} value={item.item_taxable_amount} size={[width.taxable]} onChange={(e) => onItemChange(index,e)} visible={false} />
                        <Control.Form.Number id={Name.Item.Tax1P} value={item.item_tax1_percentage} size={[width.taxP]} onChange={(e) => onItemChange(index,e)} placeholder='%'  />
                        <Control.Form.Number id={Name.Item.Tax1A} value={item.item_tax1_amount} size={[width.taxA]} onChange={(e) => onItemChange(index,e)}  />
                        <Control.Form.Number id={Name.Item.Net} value={item.item_net_amount} size={[width.netAmount]} onChange={(e) => onItemChange(index,e)}  /> 
                      </Control.Form.Item>
                      <Control.Form.Item>
                        <Control.Form.TextArea index={index} value={item.item_comment} handleItemChange={(index, e) => onItemChange(index, e)} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  ))}
                </Control.Form.List>
              </Control.Form.Table>
              <Control.Flex>
                <Control.Column size={[0,45,0,2]}>
                  <Control.Row>
                    <Field.Text value="Client" title="Payable by" size={[0,40,1]} disabled={true} />
                    <Field.Amount id={Name.Invoice.Client} value={formData.invoice_client_amount}  title="Amount" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,35,1]} require={true} disabled={true} />
                    {keyId!==Code.Key.NEW && formData.invoice_client_amount !== undefined && formData.invoice_client_amount > 0 && <Button.FrameAction title={`${clientPayment.length > 0 ?  '✓ View': '+ Add'}`} info={`${clientPayment.length > 0 ? 'Modify Payment': 'Add Payment'}`} onClick={() => Form.Show.PopupDual(iframeRef, Code.Form.Name.PAYMENT, clientPayment, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Invoice, formData.invoice_id, Code.UrlPara.Segment, formData.segment_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.Sequence, 11, Code.UrlPara.Amount, formData.invoice_client_amount)} size={[0,25,0]} className='pt6' alert={paymentClient}  /> }
                  </Control.Row>
                  <Control.Row>
                    <Field.FilterSelect id={Name.Common.insurer1Id} value={formData.insurer1_id} options={insurerOptions} setFormData={setFormData} size={[0,40,1]} require={paymentInsurer1} />
                    <Field.Amount id={Name.Invoice.Insurer1} value={formData.invoice_insurer1_amount} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,35,1]} />
                    {keyId!==Code.Key.NEW && formData.invoice_insurer1_amount !== undefined && formData.invoice_insurer1_amount > 0 && <Button.FrameAction title={`${insurer1Payment.length > 0 ?  '✓ View': '+ Add'}`} info={`${insurer1Payment.length > 0 ? 'Modify Payment': 'Add Payment'}`} onClick={() => Form.Show.PopupDual(iframeRef, Code.Form.Name.PAYMENT, insurer1Payment, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Invoice, formData.invoice_id, Code.UrlPara.Segment, formData.segment_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.Sequence, 12, Code.UrlPara.Insurer, formData.insurer1_id, Code.UrlPara.Amount, formData.invoice_insurer1_amount)} size={[0,25,0]} className='pt0' alert={paymentInsurer1} />}
                  </Control.Row>
                  <Control.Row>
                    <Field.FilterSelect id={Name.Common.insurer2Id} value={formData.insurer2_id} options={insurerOptions} setFormData={setFormData} size={[0,40,1]} require={paymentInsurer2} />
                    <Field.Amount id={Name.Invoice.Insurer2} value={formData.invoice_insurer2_amount} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,35,1]} />
                    {keyId!==Code.Key.NEW && formData.invoice_insurer2_amount !== undefined && formData.invoice_insurer2_amount > 0 && <Button.FrameAction title={`${insurer2Payment.length > 0 ?  '✓ View': '+ Add'}`} info={`${insurer2Payment.length > 0 ? 'Modify Payment': 'Add Payment'}`} onClick={() => Form.Show.PopupDual(iframeRef, Code.Form.Name.PAYMENT, insurer2Payment, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Invoice, formData.invoice_id, Code.UrlPara.Segment, formData.segment_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.Sequence, 13, Code.UrlPara.Insurer, formData.insurer2_id, Code.UrlPara.Amount, formData.invoice_insurer2_amount)} size={[0,25,0]} className='pt0' alert={paymentInsurer2} />}
                  </Control.Row>
                  <Control.Row>
                    <Field.Select id={Name.Invoice.CreditId} value={formData.credit_id} title="StockOut/Wallet" options={creditOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} selected={Code.Option.Credit.STOCKOUT} />
                    {creditVisible && (<Field.Amount id={Name.Invoice.Adjustment} value={formData.invoice_adjustment_amount} title="Case Amt (-)" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,40,1]} />)}
                  </Control.Row>
                  {creditVisible && (
                    <Control.Row>
                      <Field.FilterSelect id={Name.Invoice.GiftCardMode} value={formData.invoice_giftcard_mode} title="Mode of pay" options={mopOptions} setFormData={setFormData} size={[0,50,1]} />
                      <Field.Amount id={Name.Invoice.Giftcard} value={formData.invoice_giftcard_amount} title="Gift Card (-)" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,40,1]} />
                    </Control.Row>
                  )}
                </Control.Column>
                <Control.Column size={[0,5,0,3]}><></></Control.Column>
                <Control.Column size={[0,50,0,1]}>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount id={Name.Invoice.Gross} value={formData.invoice_gross_amount} title={Title.Gross} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} require={true} disabled={true} />
                    <Field.Amount id={Name.Invoice.Discount} value={formData.invoice_discount_amount} title={Title.Discount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]} require={true}  />
                    {/* <Field.Number id={Name.Invoice.DepositAmount} value={formData.invoice_deposit_amount} title={Title.Deposit} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,16,0]} require={true} /> */}
                  </Control.Row>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    {/* <Field.Number id={Name.Invoice.TaxableAmount} value={formData.invoice_taxable_amount} title={Title.Taxable} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,16,1]} require={true} disabled={true} /> */}
                    <Field.Amount id={Name.Invoice.Tax} value={formData.invoice_tax_amount} title={Title.Tax} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} require={true}  />
                    <Field.Amount id={Name.Invoice.Net} value={formData.invoice_net_amount} title={Title.NetAmount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]} require={true}  />
                  </Control.Row>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount id={Name.Invoice.Roundoff} value={formData.invoice_roundoff_amount} title={Title.Roundoff} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,34,1]} />
                    <Field.Amount id={Name.Invoice.Payable} value={formData.invoice_payable_amount} title={Title.Payable} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,34,0]} require={true}  />
                  </Control.Row>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount value={totalReceived} title={Title.Received} size={[1,34,1]} disabled={true} />
                    <Field.Amount value={totalBalance} title={Title.Balance} size={[1,34,0]} disabled={true}  />
                  </Control.Row>
                  {/* <Control.ButtonColumn size={[40,4,0,0,0]} align={Code.Align.RIGHT}>
                    <Button.Action title={'Generate Proforma'} info={"Generate Proforma"} onClick={generateProforma} />
                  </Control.ButtonColumn> */}
                </Control.Column>
              </Control.Flex>
            </Control.Tab.Content>
          
            <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              {keyId!==Code.Key.NEW && <Button.Create title={Code.Form.Name.PAYMENT} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.PAYMENT, Code.UrlPara.Client, formData.client_id, Code.UrlPara.Invoice, formData.invoice_id, Code.UrlPara.Segment, formData.segment_id, Code.UrlPara.Sale, formData.sale_id, Code.UrlPara.Sequence, 0)}  Privilege={PrivPayment} />}
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, width2.date],
                    [Title.SNo, width2.sno],
                    [Title.Insurance, width2.insurance],
                    [Title.MOP, width2.mop],
                    [Title.Dispenser, width2.receivedby],
                    [Title.Amount, width2.amount, Code.Align.RIGHT]
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {paymentData.map((payment, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Grid.Modify path={Utility.Join.Edit(Privilege, Code.Form.Name.PAYMENT, payment.payment_key)} iframeRef={iframeRef} Privilege={PrivPayment} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(payment.payment_date), width2.date],
                          [payment.payment_number, width2.sno],
                          [payment.insurer_name, width2.insurance],
                          [payment.mode_name, width2.mop],
                          [payment.user_first_name, width2.receivedby],
                          [Utility.Format.Amount(payment.payment_amount), width2.amount, Code.Align.RIGHT],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>
            
            <Control.Tab.Content id={Code.Tab.Tab3} isActive={activeTab === Code.Tab.Tab3}>
              <Control.Row>
                <Field.Text id={Name.Invoice.Number} value={formData.invoice_number} title={Title.SNo} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,25,1]} />
                <Field.FilterSelect id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions} setFormData={setFormData} size={[1,25,1]} />
                <Field.Date id={Name.Invoice.StartDate} value={formData.invoice_start_date} title={"Start Date"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,25,1]} />
                <Field.Date id={Name.Invoice.EndDate} value={formData.invoice_end_date} title={"Return Date"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,25,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Common.TermId} value={formData.term_id} title={"Terms & Conditions"} options={termOptions} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Select id={Name.Address.Id} value={formData.address_id} title={"Delivery Address"} options={emptyOptions} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Invoice.Comment} value={formData.invoice_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Area id={Name.Invoice.PrintableNote} value={formData.invoice_printable_note} title={"Printable Notes"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Invoice.PoNumber} value={formData.invoice_po_number} title={"PO No."} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,25,1]} />
                <Field.Text id={Name.Invoice.RefNo} value={formData.invoice_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,25,1]} />
                <Field.Area id={Name.Invoice.InternalNote} value={formData.invoice_internal_note} title={"Internal Note"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} print={true} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={onRefresh} />
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default InvoiceForm;